export default __webpack_public_path__ + "static/media/hello-light.a8ec12e7.svg";